module.exports = __webpack_public_path__ + "static/lets-watch-this.c4ef97d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/lets-watch-this.png
// module id = 476
// module chunks = 35783957827783